import React, { useEffect, useState } from 'react';
import api from '../utils/api';
import { inr, num } from '../utils/format';
import { useAuth } from '../context/AuthContext';
import { useLocationFilter } from '../context/LocationContext';

const Dashboard = () => {
  const { can } = useAuth();
  const { locationId } = useLocationFilter();
  const [closing, setClosing] = useState(null);
  const [alerts, setAlerts] = useState([]);
  const [levels, setLevels] = useState([]);
  const [locations, setLocations] = useState([]);

  useEffect(() => {
    const q = locationId ? `?locationId=${locationId}` : '';
    if (can('sales:read')) api.get(`/sales/daily-closing${q}`).then(({ data }) => setClosing(data.summary)).catch(() => {});
    if (can('thresholds:read')) api.get('/thresholds/reorder').then(({ data }) => setAlerts(data.alerts || [])).catch(() => {});
    if (can('inventory:read')) api.get(`/inventory/levels${q}`).then(({ data }) => setLevels(data.levels || [])).catch(() => {});
    api.get('/locations').then(({ data }) => setLocations(data.locations || [])).catch(() => {});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [locationId]);

  const alertsShown = locationId ? alerts.filter((a) => String(a.locationId) === String(locationId)) : alerts;
  const stockByLoc = {};
  for (const l of levels) {
    if (l.itemType !== 'product') continue;
    stockByLoc[l.location] = (stockByLoc[l.location] || 0) + Number(l.quantity);
  }

  return (
    <div>
      <div className="tiles">
        <div className="tile"><div className="k">Today's Sales</div><div className="v">{closing ? inr(closing.net) : '—'}</div></div>
        <div className="tile"><div className="k">Bills Today</div><div className="v">{closing ? closing.count : '—'}</div></div>
        <div className="tile"><div className="k">Cash / UPI / Card</div><div className="v small">{closing ? `${inr(closing.byMode.cash)} · ${inr(closing.byMode.upi)} · ${inr(closing.byMode.card)}` : '—'}</div></div>
        <div className="tile"><div className="k">Stock Alerts</div><div className="v">{alertsShown.length}</div></div>
        <div className="tile"><div className="k">Locations</div><div className="v">{locations.length}</div></div>
      </div>

      <div className="section-head"><h2>Stock alerts</h2></div>
      <div className="table-wrap" style={{ marginBottom: '1.5rem' }}>
        <table className="grid">
          <thead><tr><th>Location</th><th>Product</th><th>Variant</th><th className="right">On hand</th><th className="right">Min</th><th className="right">Max</th><th>State</th></tr></thead>
          <tbody>
            {alertsShown.map((a, i) => (
              <tr key={i}>
                <td>{a.location}</td><td>{a.item}</td><td>{a.variant || '—'}</td>
                <td className="right">{num(a.onHand)}</td><td className="right">{num(a.minQty)}</td><td className="right">{a.maxQty || '—'}</td>
                <td><span className={`badge ${a.state === 'below_min' ? 'badge-red' : 'badge-gold'}`}>{a.state === 'below_min' ? 'Below min' : 'Above max'}</span></td>
              </tr>
            ))}
            {alertsShown.length === 0 && <tr><td colSpan={7} className="empty">No stock alerts 🎉</td></tr>}
          </tbody>
        </table>
      </div>

      <div className="section-head"><h2>Finished stock by location</h2></div>
      <div className="tiles">
        {Object.entries(stockByLoc).map(([loc, qty]) => (
          <div className="tile" key={loc}><div className="k">{loc}</div><div className="v">{num(qty, 0)} <span className="muted" style={{ fontSize: '.8rem' }}>units</span></div></div>
        ))}
        {Object.keys(stockByLoc).length === 0 && <div className="muted">No finished stock yet.</div>}
      </div>
    </div>
  );
};

export default Dashboard;
